export const siteData = {
  name: "VHservice",
  tagline: "Professionel vinduespudsning til private",
  description: "Vi leverer krystalklare ruder og god service hver gang. Med base i dit lokalområde sørger vi for, at dit hjem altid præsenterer sig fra sin bedste side.",
  contact: {
    phone: "53 80 06 42",
    address: "Vigerslev allé 120 2500 Valby",
    cvr: "12345678"
  },
  links: {
    fenster: "https://fenster.dk/vhservice", // Placeholder link til Fenster
  },
  images: {
    hero: "https://assets.auxodev.dk/assets/a63bb5b8-c11e-4d14-812c-e833a8e6def1/dc5ec023-3d6c-4730-86dc-2613d8397ec9.png",
    villa: "https://assets.auxodev.dk/assets/a63bb5b8-c11e-4d14-812c-e833a8e6def1/b9461966-a4c5-4c1c-9512-a9817ef42200.jpg",
    tools: "https://assets.auxodev.dk/assets/a63bb5b8-c11e-4d14-812c-e833a8e6def1/7a24ac79-616a-4dfb-8f50-54377eb87049.jpg",
    cleaning: "https://assets.auxodev.dk/assets/a63bb5b8-c11e-4d14-812c-e833a8e6def1/8295997d-6311-4ef0-aa52-99e1d725c6e9.jpg",
    commercial: "https://assets.auxodev.dk/assets/a63bb5b8-c11e-4d14-812c-e833a8e6def1/7a24ac79-616a-4dfb-8f50-54377eb87049.jpg",
    subscription: "https://assets.auxodev.dk/assets/a63bb5b8-c11e-4d14-812c-e833a8e6def1/b9461966-a4c5-4c1c-9512-a9817ef42200.jpg"
  },
  services: [
    {
      slug: "privat",
      title: "Privat vinduespudsning",
      shortDescription: "Vi pudser alle typer vinduer i din bolig, uanset om det er lejlighed eller villa.",
      description: "Vi sørger altid for at passe på dit hjem og leverer krystalklare ruder, der lader lyset strømme ind. Vores private vinduespudsning er skræddersyet til dine behov, uanset om du bor i lejlighed, rækkehus eller en stor villa.",
      fullContent: `
        Hvorfor vælge os til dit hjem?
        Hos VHservice forstår vi, at dit hjem er din base. Derfor møder vi altid op med et smil og stor respekt for dit inventar. Vi pudser ikke bare ruderne; vi tørrer også rammerne af, så det samlede indtryk er perfekt.

        Vi tilbyder:
        - Indvendig og udvendig pudsning.
        - Afvaskning af karme og rammer.
        - Pudsning af glaspartier, udestuer og ovenlys.
        - Fleksible tider, der passer ind i din hverdag.

        Vi benytter miljøvenlige sæber, der efterlader et stribefrit resultat uden at skade dine planter eller miljøet omkring din bolig.
      `,
      icon: "Home",
      image: "https://assets.auxodev.dk/assets/a63bb5b8-c11e-4d14-812c-e833a8e6def1/b9461966-a4c5-4c1c-9512-a9817ef42200.jpg"
    },
    {
      slug: "abonnement",
      title: "Abonnementsordning",
      shortDescription: "Slip for bekymringerne med en fast aftale. Vi kommer hver 4. eller 8. uge.",
      description: "Vi kommer hver 4. eller 8. uge og sørger for, at dine vinduer altid er rene. Det er den nemmeste og mest økonomiske løsning for dig, der vil have vedvarende rene ruder.",
      fullContent: `
        Glem alt om beskidte ruder – vælg abonnement
        Med en abonnementsordning hos VHservice skal du aldrig mere huske på at bestille vinduespudseren. Vi holder styr på intervallet for dig, så dine vinduer altid står skarpt.

        Fordele ved abonnement:
        - Fast lav pris – du sparer penge i forhold til enkeltbestillinger.
        - Altid rene ruder året rundt.
        - Ingen bindingsperiode – du kan opsige eller ændre aftalen løbende.
        - Vi giver lyd inden ankomst, så du er forberedt.

        De fleste af vores kunder vælger et interval på hver 4. eller 8. uge. Dette sikrer, at snavs og salt (hvis du bor nær vandet) aldrig når at sætte sig fast, hvilket også forlænger dine vinduers levetid.
      `,
      icon: "Calendar",
      image: "https://assets.auxodev.dk/assets/a63bb5b8-c11e-4d14-812c-e833a8e6def1/8295997d-6311-4ef0-aa52-99e1d725c6e9.jpg"
    }
  ],
  benefits: [
    {
      title: "Pålidelig service",
      text: "Vi overholder altid vores aftaler og kommer til tiden."
    },
    {
      title: "Miljøvenlige midler",
      text: "Vi bruger kun svanemærkede produkter, der skåner miljøet."
    },
    {
      title: "Konkurrencedygtige priser",
      text: "Høj kvalitet behøver ikke koste en formue. Få et uforpligtende tilbud."
    }
  ]
};

export const coverageAreas = [
  "Bagsværd",
  "Ballerup",
  "Brønshøj",
  "Charlottenlund",
  "Frederiksberg",
  "Gentofte",
  "Glostrup",
  "Herlev",
  "Hvidovre",
  "Indre By",
  "Kongens Lyngby",
  "Nordvest",
  "Nørrebro",
  "Østerbro",
  "Rødovre",
  "Søborg",
  "Sundby på Amager",
  "Sydhavnen",
  "Vanløse"
];

